module.exports = __webpack_public_path__ + "img/glicon.ca08c965.svg";